import http from "@/services/http";

const getRoles = () => http.get("permissions/roles")
const getPermissionsMatrix = (roleId) => http.get("permissions/matrix", { params: { role_id: roleId } })
const updatePermissions = (roleId, permissions) => http.post("permissions/update", { role_id: roleId, permissions })
const createRole = (role) => http.post("permissions/roles", role)

export default {
  getRoles,
  getPermissionsMatrix,
  updatePermissions,
  createRole
}